import EChartsController from "../../echarts_controller"

export default class extends EChartsController {
  static values = {
    ratio: Number,
    color: String,
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)
    this.renderChart(this.chart, this.ratioValue, this.colorValue)
  }

  renderChart(chart, ratio, color) {
    const confirmed = Math.max(0, Math.min(1, ratio))
    const remaining = 1 - confirmed

    chart.setOption({
      tooltip: { show: false },
      series: [
        {
          type: "pie",
          radius: ["55%", "100%"],
          silent: true,
          startAngle: 90,
          label: { show: false },
          labelLine: { show: false },
          emphasis: { disabled: true },
          data: [
            {
              value: confirmed,
              itemStyle: { color: color },
            },
            {
              value: remaining,
              itemStyle: { color: "rgba(255,255,255,0.08)" },
            },
          ],
        },
      ],
    })
  }
}
